<template lang="pug">
  .season-event.section
    .event-header
      img(:src="banner.pic")
      a(:href="banner.link",target="_blank")
    transition(name="fade")
      .event-content
        .left
          .img-container
            img(
              :src="products[activeIndex].sqImg"
            )
        .right
          .title {{products[activeIndex].title}}
          .functions
            .product-block-pricing
              .price-initial {{products[activeIndex].origPrice}}
              .price
                .number
                  span $
                  |{{products[activeIndex].price}}
            .product-block-function
              a.btn.btn-rect-red(:href="products[activeIndex].url")
                p 搶購
    .event-thumb
      swiper(
        :options="seasonEventThumb",
        ref="eventThumb")
        swiper-slide(
          v-for="(card,cid) in products",
          :key="'card-'+cid",
          @click="test(eid,cid)"
          )
          .img-container
            img(
              :src="card.sqImg"
            )
</template>

<script>
export default {
  name: 'events-carousel',
  components:{
  },
  props:{
    products: {
      type:Array,
      required: true,
      default: function(){
        return [];
      }
    },
    banner: {
      type:Object,
      required: true,
      default: function(){
        return {};
      }
    }
  },
  data(){
    return{
      activeIndex: 0,
      seasonEventThumb:{
        slidesPerView: 'auto',
        initialSlide: 0,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        freeMode: true,
        slideToClickedSlide: true,
        loop: false,
        on:{
          tap:()=>{
            console.log(this.$refs.eventThumb.swiper.clickedIndex)
            this.activeIndex = this.$refs.eventThumb.swiper.clickedIndex
          }
        }
      },
    };
  },
  methods: {
    
  },
  watch:{
    // events(){
    //   // console.log('updated ads')
    //   this.adsSwiper = {
    //     slidesPerView: 1,
    //     spaceBetween: 8,
    //     autoplay:{
    //       delay: 5000,
    //       disableOnInteraction: true
    //     },
    //     loop: true
    //   }
    // }
  }
}
</script>

<style lang="scss">
  
</style>
